import { render, staticRenderFns } from "./AddPlaces.vue?vue&type=template&id=7f3a67c8&scoped=true&"
import script from "./AddPlaces.vue?vue&type=script&lang=js&"
export * from "./AddPlaces.vue?vue&type=script&lang=js&"
import style1 from "./AddPlaces.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3a67c8",
  null
  
)

export default component.exports